// =============================================================================
// ⚠️  MÓDULO FEA — NO IMPLEMENTADO / SOLO PROTOTIPO
// =============================================================================
// Este componente es código de prueba (mock). La lógica de firma usa Math.random()
// y no realiza ninguna llamada real a AWS KMS Lambda.
//
// La vista está DESHABILITADA en producción hasta que se implemente la integración
// real con AWS KMS (clave asimétrica RSA-3072) y el microservicio de firma FEA.
//
// La ruta /firma en App.jsx mantiene la protección de rol (boss/staff) como
// medida de seguridad adicional mientras el módulo está pendiente.
//
// TODO: Implementar integración real:
//   - Endpoint backend: POST /api/v1/firma/documentos/{id}
//   - Lambda: firmarDocumento (KMS sign → embed QR en PDF)
//   - Eliminar MOCK_QUEUE y reemplazar por GET /api/v1/firma/cola
// =============================================================================

export default function FirmaQR() {
  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <div
        className="glass-card"
        style={{
          maxWidth: 520,
          width: '100%',
          textAlign: 'center',
          padding: '3rem 2.5rem',
          border: '1.5px solid rgba(234, 179, 8, 0.3)',
        }}
      >
        <div style={{ fontSize: '3.5rem', marginBottom: '1.25rem' }}>🚧</div>

        <h2
          style={{
            margin: '0 0 0.5rem',
            fontSize: '1.4rem',
            fontWeight: 700,
            color: 'var(--gray-100)',
          }}
        >
          Módulo de Firma FEA
        </h2>

        <p
          style={{
            color: 'var(--gray-400)',
            fontSize: '0.9rem',
            marginBottom: '1.75rem',
            lineHeight: 1.6,
          }}
        >
          Este módulo está en desarrollo y aún no está habilitado.
          <br />
          La integración con <strong style={{ color: 'var(--gray-300)' }}>AWS KMS</strong> para
          Firma Electrónica Avanzada (FEA) se encuentra pendiente de implementación.
        </p>

        <div
          className="alert"
          style={{
            background: 'rgba(234, 179, 8, 0.08)',
            border: '1px solid rgba(234, 179, 8, 0.25)',
            borderRadius: 10,
            padding: '0.85rem 1.1rem',
            fontSize: '0.8rem',
            color: 'var(--gray-300)',
            textAlign: 'left',
            lineHeight: 1.6,
          }}
        >
          <strong style={{ color: '#eab308' }}>⚠️ Pendiente:</strong>{' '}
          Para habilitar este módulo se requiere completar la integración con el
          servicio Lambda de firma y la clave asimétrica RSA-3072 en AWS KMS.
          Contacta al equipo de desarrollo.
        </div>
      </div>
    </div>
  );
}

